// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { filterListStyles } from "@awc/Overrides/Widgets/ProductList/ProductListFilterList";
import { DivWrapper } from "@awc/XDL/constants";
import Close from "@awc/XDL/Icons/Close";
import { color, createLinkIconStyles, getSystemColor, mergeWithCss } from "@awc/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";
import { StyledTypography } from "@insite/mobius/Link";
import { css } from "styled-components";

filterListStyles.filterContainer = {
    css: css`
        ${({ showTableLayout }: any) => !showTableLayout && `border: 1px solid ${getSystemColor("common.black")}`};
    `,
};

filterListStyles.wrapper = {
    ...mergeWithCss(filterListStyles.wrapper, {
        css: css`
            ${({ showTableLayout }: any) =>
                !showTableLayout && `background-color: ${getSystemColor("primary")}; padding: 8px 12px;`};
        `,
    }),
};

filterListStyles.filterText = {
    ...filterListStyles.filterText,
    color: "common.ui1",
    css: css`
        margin-bottom: 0;
        ${({ anyActiveFilters }: any) => anyActiveFilters && `margin-bottom: 8px`};
    `,
};

filterListStyles.clearAllLink = {
    ...createLinkIconStyles({
        icon: Close,
        linkStyles: {
            css: css`
                ${({ showTableLayout }: any) => showTableLayout && `margin-bottom: 14px`};
                ${IconWrapper},${StyledTypography} {
                    color: ${color("common.white")};
                }
                &:hover {
                    ${StyledTypography} {
                        text-decoration: underline;
                    }
                }
            `,
            hoverStyle: {
                color: getSystemColor("common.white"),
            },
            icon: {
                iconProps: {
                    size: 8,
                },
                position: "left",
            },
        },
    }),
};

filterListStyles.searchWithinWrapper = {
    css: css`
        ${DivWrapper} {
            padding: 8px 12px 10px;
            display: flex;
            flex-direction: column;
            gap: 8px;
        }
    `,
};

filterListStyles.filterTag = {
    mergeCss: true,
    color: "common.white",
    typographyProps: {
        color: "primary",
    },
    iconProps: {
        color: "primary",
    },
    css: css`
        button:hover {
            ${IconWrapper} {
                color: ${color("common.ui8")};
            }
        }
    `,
};
